import { useEffect, useState } from 'react';
import { plugin, debug } from 'light-component';
import { TreeSelect } from 'antd';
import { Require } from '../component';
import { useTranslation } from '../../i18n';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { FormBlock, FormBlockTree, FormTreeSelectProps } from './types';

export function WidgetFormTreeSelect(props: FormTreeSelectProps): ReactElement {
  debug.widget('dashboard FormTreeSelect', props);
  const [t] = useTranslation();
  const [options, setOptions] = useState<FormBlockTree[]>([]);

  const onChange = (ids: string[]): void => {
    const changeValues = ids.length > 0 ? ids : [];
    props.onChange?.(changeValues);
  };

  const buildTree = (data: FormBlock[]): FormBlockTree[] => {
    // 过滤掉不需要的类型
    const filteredData = data.filter(item => !['ShotEyesUserSelect', 'Input', 'TextArea'].includes(item.type));

    // 创建一个映射来存储所有节点
    const nodeMap = new Map<string, FormBlockTree>();
    const roots: FormBlockTree[] = [];

    // 初始化所有节点
    filteredData.forEach(item => {
      nodeMap.set(item.name, {
        ...item,
        value: item.name,
        title: item.description,
        key: item.name,
        children: []
      });
    });

    // 构建树结构
    filteredData.forEach(item => {
      const node = nodeMap.get(item.name)!;

      if (item.path.length === 0) {
        // 没有路径信息，作为根节点
        roots.push(node);
      } else {
        // 根据路径找到父节点
        let parent: FormBlockTree | null = null;
        for (let index = item.path.length - 1; index >= 0; index -= 1) {
          parent = nodeMap.get(item.path[index]) ?? null;
          if (parent != null) break;
        }

        if (parent != null) {
          parent.children!.push(node);
        } else {
          // 找不到父节点，则作为根节点
          roots.push(node);
        }
      }
    });

    return roots;
  };

  useEffect(() => {
    const options = props.options?.filter(item => !['ShotEyesUserSelect', 'Input', 'TextArea'].includes(item.type));
    const tree = buildTree(options ?? []);
    setOptions(tree);
  }, [props.options]);

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <TreeSelect
        className={styles.treeSelect}
        treeIcon
        value={props.value ?? []}
        placeholder={t('请选择')}
        showSearch
        allowClear
        autoClearSearchValue
        size='middle'
        showCheckedStrategy={TreeSelect.SHOW_ALL}
        treeCheckable
        treeNodeFilterProp='title'
        treeLine={{ showLeafIcon: false }}
        popupMatchSelectWidth={false}
        treeData={options}
        onChange={onChange}
        multiple
        maxTagCount={3}
      />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'form-tree', component: WidgetFormTreeSelect });
